import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getApiKey } from '../services/difyApi';

const TestApiKey: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [manualApiKey, setManualApiKey] = useState('');
  
  // Get the current API key
  const currentApiKey = getApiKey();
  
  // Extract URL parameters directly
  const urlParams = new URLSearchParams(window.location.search);
  const urlApiKey = urlParams.get('api_key');
  
  // Log all relevant information
  useEffect(() => {
    console.log('TestApiKey Component - Debug Info:');
    console.log('Current URL:', window.location.href);
    console.log('Location pathname:', location.pathname);
    console.log('Location search:', location.search);
    console.log('URL Parameters:', Object.fromEntries(urlParams.entries()));
    console.log('API Key from URL params:', urlApiKey);
    console.log('API Key from getApiKey():', currentApiKey);
  }, [location, urlApiKey, currentApiKey]);
  
  const handleSetApiKey = () => {
    if (manualApiKey.trim()) {
      const params = new URLSearchParams(location.search);
      params.set('api_key', manualApiKey.trim());
      navigate(`${location.pathname}?${params.toString()}`);
    }
  };
  
  const handleClearApiKey = () => {
    const params = new URLSearchParams(location.search);
    params.delete('api_key');
    navigate(`${location.pathname}${params.toString() ? `?${params.toString()}` : ''}`);
  };
  
  return (
    <div className="p-8 max-w-3xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">API Key Test Page</h1>
      
      <div className="bg-gray-100 p-4 rounded-lg mb-6">
        <h2 className="text-lg font-semibold mb-2">Current URL Information</h2>
        <div className="mb-2">
          <span className="font-medium">Full URL:</span> {window.location.href}
        </div>
        <div className="mb-2">
          <span className="font-medium">Path:</span> {location.pathname}
        </div>
        <div className="mb-2">
          <span className="font-medium">Search Parameters:</span> {location.search}
        </div>
      </div>
      
      <div className="bg-gray-100 p-4 rounded-lg mb-6">
        <h2 className="text-lg font-semibold mb-2">API Key Information</h2>
        <div className="mb-2">
          <span className="font-medium">API Key from URL:</span> {urlApiKey || '(none)'}
        </div>
        <div className="mb-2">
          <span className="font-medium">API Key from getApiKey():</span> {currentApiKey}
        </div>
      </div>
      
      <div className="bg-white p-4 border rounded-lg mb-6">
        <h2 className="text-lg font-semibold mb-2">Test API Key</h2>
        <div className="flex gap-2 mb-4">
          <input
            type="text"
            value={manualApiKey}
            onChange={(e) => setManualApiKey(e.target.value)}
            placeholder="Enter API key to test"
            className="flex-1 p-2 border rounded"
          />
          <button
            onClick={handleSetApiKey}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            Set API Key
          </button>
          <button
            onClick={handleClearApiKey}
            className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
          >
            Clear API Key
          </button>
        </div>
      </div>
      
      <div className="mt-6">
        <a href="/" className="text-blue-500 hover:underline">Back to Chat</a>
      </div>
    </div>
  );
};

export default TestApiKey;
